module.exports = __webpack_public_path__ + "static/media/Logo-with-words-TRANSPARENT.04d65fa0.PNG";